module.exports = __webpack_public_path__ + "static/stop-loss-cc4e3ab2f02b97bb9e2c043eb4d2bf22.jpg";